// src/components/About.js
import React, { useEffect, useContext, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import ProfileSidebar from '../profile/ProfileSidebar';

const MyActivity = () => {

    const { user, isAuthenticated } = useContext(AppContext);

    const [profileData, setProfileData] = useState({
        name: user?.data?.name || '',  
        email: user?.data?.email || '', 
      });
    
      // Fetch Bearer token (Assuming it's stored in localStorage)
      const token = localStorage.getItem('authToken');
      
    return (
        <div className="container mt-5">
            <div className="row">
              
              <ProfileSidebar />

                {/* Profile Details */}
                <div className="col-md-8">
                    <div className="card p-4 mb-4">
                        <h5 className="mb-4">My Activity</h5>
                       
                    </div>

                </div>
            </div>
        </div>
    );
};

export default MyActivity;
